
import { GetterTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import { IPropertyRoomModel } from "../../../../models/property";

const roomGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
	service: (state: IPropertyEditState) => {
		return state.service;
	},
	listOfRooms: (state: IPropertyEditState): IPropertyRoomModel[] => {
        return state.property.Rooms || [];
	},
	currentRoom: (state: IPropertyEditState): IPropertyRoomModel => {
		return state.currentRoom;
	},
	previousRoom: (state: IPropertyEditState): IPropertyRoomModel => {
		return state.previousRoom;
	}
};

export default roomGetters;
